import template from 'text!./Table.html';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            schedule: '&'
        },
        template: template
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/readonly/Table/Table.js
// module id = 389
// module chunks = 0